export const WHITEWHALE_ADDRESS = '0x082138b691c47773a8d2ffee453f665184959a53'

export const WHITEWHALE_ABI =
[
    {
        'gas': 106958,
        'inputs': [],
        'name': "buyMe",
        'outputs': [],
        'stateMutability': "payable",
        'type': "function"
    },
    {
        'gas': 1181,
        'inputs': [],
        'name': "owner",
        'outputs': [
            {
                'name': "",
                'type': "address"
            }
        ],
        'stateMutability': "view",
        'type': "function"
    },
    {
        'gas': 1211,
        'inputs': [],
        'name': "pricePaid",
        'outputs': [
            {
                'name': "",
                'type': "uint256"
            }
        ],
        'stateMutability': "view",
        'type': "function"
    }
]
